import { styled } from '@linaria/react';

export const Wrapper = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	gap: 4px;
`;

export const LabelRow = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 4px;
	gap: var(--gap-s);
`;
